import { Card, CardActions, CardContent, CircularProgress, Grid, IconButton } from '@material-ui/core';
import { green } from '@material-ui/core/colors';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Edit, Email } from '@material-ui/icons';
// Material
// Redux
import { useSelector } from 'react-redux';

import { EnumAppSignatureFormat } from '../../redux/scholarship.models';
import { selectSendingEmail } from '../../redux/scholarship.selectors';
import UploadButton from '../UploadForm/upload-button';

const useStyles = makeStyles(() =>
  createStyles({
    alignRight: {
      display: 'flex',
      justifyContent: 'end',
      width: '50%',
      backgroundColor: '#fafafa'
    },
    alignLeft: {
      display: 'flex',
      justifyContent: 'start',
      width: '50%',
      backgroundColor: '#fafafa'
    },
    emailProgress: {
      color: green[500],
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -11,
      marginLeft: -11
    }
  })
);

export const ThirdPartyCard = ({ signatures, handleEdit, resendEmail, handleSignature }) => {
  const classes = useStyles();
  const sendingEmail: boolean = useSelector(selectSendingEmail);

  return (
    <>
      {signatures.map((row: any, index: number) => (
        <Card variant="outlined" key={index} style={{ marginTop: '20px' }}>
          <CardContent>
            <strong>Name:</strong> {row.firstName} {row.lastName}
            <br />
            <strong>Format:</strong> {row.signatureFormat === EnumAppSignatureFormat.DIGITAL ? 'Email' : 'Paper'}
            <br />
            <strong>Contact:</strong> {row.signatureFormat === EnumAppSignatureFormat.DIGITAL ? row.email : 'Download Form'}
            <br />
            <strong>Status:</strong> {row.signed ? 'Signed' : 'Pending'}
          </CardContent>
          <CardActions>
            <Grid container spacing={2}>
              <Grid item className={classes.alignLeft}>
                {row.signatureFormat === EnumAppSignatureFormat.DIGITAL ? undefined : (
                  <UploadButton
                    appId={row.id}
                    accept={['image/*', 'application/pdf']}
                    dataSource={row}
                    disabled={!!row.filePath}
                    noClick={true}
                    noDrag={true}
                    noKeyboard={true}
                    section={'signature'}
                    userId={row.userId}
                    handleSignature={handleSignature}
                  />
                )}
              </Grid>
              <Grid item className={classes.alignRight}>
                <IconButton size={'small'} onClick={() => handleEdit(row.signatureId)} title={'Edit'}>
                  <Edit />
                </IconButton>
                {row.signatureFormat === EnumAppSignatureFormat.DIGITAL && (
                  <IconButton size={'small'} onClick={() => resendEmail(row)} title={'Send Email Again'}>
                    <Email />
                    {sendingEmail && <CircularProgress size={22} className={classes.emailProgress} />}
                  </IconButton>
                )}
              </Grid>
            </Grid>
          </CardActions>
        </Card>
      ))}
    </>
  );
};
